<button matIconButton id="geocodingButton" class="map-control geocoding-btn primary-button" disableRipple
  (click)="ontoggle();$event.stopPropagation();">
  <mat-icon>search</mat-icon>
</button>
<!--*ngIf="!isOpen"-->


<div [@preventInitialChildAnimations]>

  @if (isOpen()) {
  <div class="geocoding-form" [@openClose]="isOpen() ? 'open' : 'close'" cdkOverlayOrigin #formOrigin="cdkOverlayOrigin"
    [ngClass]="{'active': active() ,'no-bottom-border-radius':trigger.panelOpen || showSearchTip() || isValidCoords()!==undefined }"
    id="geocodingForm">
    <!-- <div class="geocoding-field">    -->
    <mat-form-field class="geocoding-field">

      <input matInput type="text" placeholder="{{ 'geocoding.placeholder' | translate }}" aria-label="Number"
        id="searchInput" #searchInputEl #matInput="matInput" #trigger="matAutocompleteTrigger"
        [formControl]="autoCompleteControl" [matAutocomplete]="auto" (keyup.enter)="onNumberedInputKeyUp($event)"
        (focus)="onFocus($event)">

      <!-- (blur)="onBlur()"  -->
      <span style="margin-right: 15px; align-items: center; display: flex;" matSuffix>
        @if (loading()) {
        <mat-spinner color="orange" diameter=20></mat-spinner>
        }
      </span>
      @if (!loading()) {
      <button [disableRipple]="true" style="font-size: 12px" matSuffix mat-icon-button aria-label="Clear" class="suffix"
        (click)="$event.stopPropagation();clearOrHideInput($event)">
        <mat-icon [ngClass]="matInput.focused ? 'focused' : 'not-focused'">close</mat-icon>
      </button>
      }
      <button [disableRipple]="true" matPrefix mat-icon-button aria-label="Clear" class="prefix"
        (click)="onPrefixBtnClick($event)">
        <mat-icon [ngClass]="(isValidCoords())?'valid':'not-valid'" title="{{ getInputIconTitle() | translate }}">{{
          getInputIcon()}}</mat-icon>
      </button>
      <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption="true" [displayWith]="getFeatureName"
        (optionSelected)="onSelect($event.option.value)" (opened)="onPanelOpened()" (closed)="onPanelClosed()">
        @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option" [ngClass]="option.properties.locationtype" class="geocoding-options"
          classList="geocoding-options">
          {{option.properties.name}}
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <!-- </div> -->
    <!-- <button mat-icon-button (click)="showSearchTip()=!showSearchTip()" style="position: fixed;top:120px;right: 800px;">klikc</button> -->
    <!-- <button mat-icon-button (click)="trigger.openPanel()" style="position: fixed;top:90px;right: 800px;">klikc</button> -->
    <!--  (backdropClick)="showSearchTip()=false;active()=false; isValidCoords()=undefined"  -->
    <!-- search tip ?-->
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="formOrigin"
      [cdkConnectedOverlayOpen]="showSearchTip() || (isValidCoords() !== undefined)?true:false"
      [cdkConnectedOverlayHasBackdrop]="false" cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
      (overlayOutsideClick)="matInput.focused ? '': searchTipOutSideClick($event)">
      <!-- -->
      <div class="search-tip-panel" [@showHideTip] [ngStyle]="{'width.px': (trigger._getHostWidth())}"
        (click)="$event.stopPropagation()">
        <div class="search-tip-inner">
          @if (showSearchTip() && !(isValidCoords() !== undefined)) {
          <div>
            <span>tip</span>
            <div class="content">
              <p>
                {{ 'geocoding.search_tip' | translate }}
              </p>
            </div>
          </div>
          }
          @if (isValidCoords() !== undefined) {
          <div>
            <span>{{ 'geocoding.tip' | translate }}</span>
            <div class="content">
              <ul>
                <li>{{ 'geocoding.tip-lb08' | translate }} <span class="coords-example">654321.09,&nbsp;654321.09</span>
                </li>
                <li>{{ 'geocoding.tip-lb72' | translate }} <span class="coords-example">123456.78,&nbsp;123456.78</span>
                </li>
                <li>{{ 'geocoding.tip-wgs84' | translate }} <span class="coords-example">51.123456,&nbsp;5.123465</span>
                  {{'geocoding.or'|translate}} <span class="coords-example">50° 12' 34.5"N , 4° 12' 34.5"E</span></li>
                <li>{{ 'geocoding.tip-utm' | translate }} <span
                    class="coords-example">31N&nbsp;600000,&nbsp;5678000</span>
                </li>
              </ul>
            </div>
            @if (sheetsInMouseProjection) {
            <div>
              <span>{{ 'geocoding.mapindex-tip' | translate }}</span>
              <div class="content">
                <ul>
                  <li>{{ 'geocoding.mapindexlevel_0-tip' | translate }} <span
                      class="coords-example">32;&nbsp;24;&nbsp;50A&nbsp;</span>
                  </li>
                  <li>{{ 'geocoding.mapindexlevel_1-tip' | translate }} <span
                      class="coords-example">59/6n;&nbsp;04A/3s</span>
                  </li>
                  <li>{{ 'geocoding.mapindexlevel_2-tip' | translate }} <span class="coords-example">17/3n-d7</span>
                  </li>
                  <li>{{ 'geocoding.mapindexlevel_3-4-tip' | translate }} <span class="coords-example">47/4s-d9-y
                      {{'geocoding.or'|translate}} 47/4s-d9-yz</span>
                  </li>
                </ul>
              </div>
            </div>
            }
          </div>
          }
        </div>
      </div>
    </ng-template>
    <!-- <div *ngIf="isValidCoords() !== undefined" class="coords-tip">
<span><em>{{ 'geocoding.tip' | translate }}</em></span>
<ul>
  <li>{{ 'geocoding.tip-lb08' | translate }}</li>
  <li>{{ 'geocoding.tip-lb72' | translate }}</li>
  <li>{{ 'geocoding.tip-wgs84' | translate }}</li>
</ul>
</div> -->
  </div>
  }
</div>